import { render, staticRenderFns } from "./TrendShopTile.vue?vue&type=template&id=51bad6ac&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./TrendShopTile.vue?vue&type=script&lang=js&"
export * from "./TrendShopTile.vue?vue&type=script&lang=js&"
import style0 from "./TrendShopTile.vue?vue&type=style&index=0&id=51bad6ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bad6ac",
  null
  
)

export default component.exports